import { Controller } from "stimulus";

export default class extends Controller {
  initialize() {
    this.transporterSelect = document.getElementById(
      "inland_transport_transporter_organization_id"
    );
    this.emptyGateInOnDeliveryCheckbox = document.getElementById(
      "inland_transport_empty_gate_in_on_delivery_date"
    );
  }

  connect() {
    // magic to fire a native event from select2
    $(this.transporterSelect).on("select2:select", function () {
      let event = new Event("change", { bubbles: true });
      this.dispatchEvent(event);
    });
  }

  transporterChange(e) {
    let selectedTransporterOption = e.target[e.target.selectedIndex];

    this.emptyGateInOnDeliveryCheckbox.checked =
      selectedTransporterOption.dataset.emptyGateInOnDelivery === "true";
  }
}
